import { Session } from '@utils/types/editors/sessions.ts';
import { BaseResponse } from '@utils/types/shared/base.ts';

export enum PermissionType {
  NO_ACCESS = 0,
  READ = 1,
  WRITE = 2
}

export type Permission = {
  group_id: number | null;
  permission: PermissionType;
};

export type Folder = {
  id: number;
  can_delete?: boolean | null;
  name: string;
  parent_folder: string;
  documents?: DocumentResponse[];
  folders?: Folder[];
  parent_id: number | null;
  child_folders: Folder[];
  permissions: Permission[];
  last_modified: string;
  diarization: boolean;
  date_upload: string;
  breadcrumbs?: { id: number; name: string }[];
};

export type DocumentResponse = {
  live_transcript?: boolean;
  filename: string;
  id: string;
  last_modified: string;
  language: string;
  type: string;
  session: Session;
  session_mode?: 'decode' | 'align' | 'upload' | null;
};

export type FolderDocument = {
  folders: Folder[];
  documents: DocumentResponse[];
  child_folders?: Folder[];
};

export type CreateFolderResponse = {
  id: number;
  name: string;
};

export type FoldersResponse = BaseResponse<FolderDocument>;
